<template>
  <div class="block" style="margin-bottom: 40px">
    <div class="title">
      <img src="//cdn.hongbaoxd.com/images/7a6376620cc249cd275dcd3d10cec1f2.png" alt="" height="12">
      <span>尚未开始</span>
      <img class="horizon-reverse" src="//cdn.hongbaoxd.com/images/7a6376620cc249cd275dcd3d10cec1f2.png" alt="" height="12">
    </div>

    <div class="task row" v-for="(task, index) in upcoming" :key="index" @click="inComing()">
      <img src="//cdn.hongbaoxd.com/images/3614db08e24cc4d56b96435d64f95cbd.png" alt="">
      <span class="desc">{{task.start_at}} 开抢</span>
      <span class="unit">元奖励</span>
      <span class="reward">{{task.reward}}</span>
    </div>

    <div class="task row empty" v-if="upcoming.length === 0">
      <img src="//cdn.hongbaoxd.com/images/5782feea5e3a1a882082af4560ba07d3.png" alt="">
      <span class="desc">暂无试玩</span>
    </div>
  </div>
</template>
<style lang='scss' scoped>
  @import 'block';
</style>
<script>
import { mapState } from 'vuex'
import { $toast } from '@/views/common/Loading.js'
export default {
  computed: {
    ...mapState({
      upcoming: state => state.dashboard.taskInfo.upcoming
    })
  },
  methods: {
    inComing () {
      $toast.show('任务还没开始，敬请期待', 2000)
    }
  }
}
</script>
